export default "__VITE_ASSET__DQx_UeAf__"